import { FileSettingsContext } from "./file-settings-context";
export const FileSettingsConsumer = FileSettingsContext.Consumer;